import Vue from 'vue'
import Router from 'vue-router'
import security from '@/security'
import _403 from '@/views/403'
import _404 from '@/views/404'

import axios from 'axios'
import qs from 'qs'

Vue.use(Router)

// 创建路由实例
const router = new Router({
	mode: 'history',
	routes: [{
			path: '/login/admin',
			name: '管理员登录',
			component: function (resolve) {require(['./views/LoginAdmin.vue'], resolve)}
		}, {
			path: '/login',
			name: '用户登录',
			component: function (resolve) {require(['./views/Login.vue'], resolve)}
		}, {
			path: '/',
			name: '首页',
			component: function (resolve) {require(['./views/home/Home.vue'], resolve)},
			children: [
				{path: '/mc/me', name: '个人信息', component: function (resolve) {require(['./views/mc/me/Edit.vue'], resolve)}},
				{path: '/admin/config', name: '系统参数设置', component: function (resolve) {require(['./views/admin/config/Edit.vue'], resolve)}},
				{path: '/admin/setting', name: '业务参数设置', component: function (resolve) {require(['./views/admin/setting/Edit.vue'], resolve)}},
				{path: '/admin/user/index', name: '用户管理', component: function (resolve) {require(['./views/admin/user/Index.vue'], resolve)}},
				{path: '/admin/user/edit', name: '编辑用户', component: function (resolve) {require(['./views/admin/user/Edit.vue'], resolve)}},
				{path: '/admin/role/index', name: '角色管理', component: function (resolve) {require(['./views/admin/role/Index.vue'], resolve)}},
				{path: '/admin/role/edit', name: '编辑角色', component: function (resolve) {require(['./views/admin/role/Edit.vue'], resolve)}},
				{path: '/admin/shop/index', name: '微商城管理', component: function (resolve) {require(['./views/admin/shop/Index.vue'], resolve)}},
				{path: '/admin/shop/edit', name: '微商城驾校', component: function (resolve) {require(['./views/admin/shop/Edit.vue'], resolve)}},
				{path: '/admin/school/index', name: '驾校管理', component: function (resolve) {require(['./views/admin/school/Index.vue'], resolve)}},
				{path: '/admin/school/edit', name: '编辑驾校', component: function (resolve) {require(['./views/admin/school/Edit.vue'], resolve)}},
				{path: '/admin/school/headmasterindex', name: '校长助手管理', component: function (resolve) {require(['./views/admin/school/HeadmasterIndex.vue'], resolve)}},
				{path: '/admin/school/fxindex', name: '分招系统管理', component: function (resolve) {require(['./views/admin/school/FxIndex.vue'], resolve)}},
				{path: '/admin/school/lbindex', name: '营销系统管理', component: function (resolve) {require(['./views/admin/school/LbIndex.vue'], resolve)}},
				{path: '/admin/school/headmasteredit', name: '编辑校长助手', component: function (resolve) {require(['./views/admin/school/HeadmasterEdit.vue'], resolve)}},
				{path: '/admin/school/signupbill', name: '驾校账单管理', component: function (resolve) {require(['./views/admin/school/SignupBill.vue'], resolve)}},
				{path: '/admin/order/index', name: '订单管理', component: function (resolve) {require(['./views/admin/order/Index.vue'], resolve)}},
				{path: '/mc/school/index', name: '远光灯学车', component: function (resolve) {require(['./views/mc/school/Index.vue'], resolve)}},
				{path: '/mc/school/aftersalefee', name: '驾校服务费', component: function (resolve) {require(['./views/mc/school/AfterSaleFee.vue'], resolve)}},
				{path: '/mc/school/serverfee', name: '驾校空间费', component: function (resolve) {require(['./views/mc/school/ServerFee.vue'], resolve)}},
				{path: '/mc/school/fxfee', name: '分招系统', component: function (resolve) {require(['./views/mc/school/FxFee.vue'], resolve)}},
				{path: '/mc/school/lbfee', name: '营销系统', component: function (resolve) {require(['./views/mc/school/LbFee.vue'], resolve)}},
				{path: '/mc/school/facefee', name: '驾校门禁服务费', component: function (resolve) {require(['./views/mc/school/FaceFee.vue'], resolve)}},
				{path: '/mc/school/signupbill', name: '驾校报名账单', component: function (resolve) {require(['./views/mc/school/SignupBill.vue'], resolve)}},
				{path: '/mc/school/headmaster', name: '校长助手', component: function (resolve) {require(['./views/mc/school/Headmaster.vue'], resolve)}},
				{path: '/mc/school/xiaochengxu', name: '驾校公众号营销小程序', component: function (resolve) {require(['./views/mc/school/xiaochengxu.vue'], resolve)}},
				{path: '/mc/shop/serverfee', name: '微商城', component: function (resolve) {require(['./views/mc/shop/ServerFee.vue'], resolve)}},
				{path: '/mc/order/index', name: '支付记录', component: function (resolve) {require(['./views/mc/order/Index.vue'], resolve)}},
			]
		}, {
			path: '/403',
			name: '禁止访问',
			component: function (resolve) {require(['./views/403.vue'], resolve)}
		}, {
			path: '/*',
			name: '页面不存在',
			component: function (resolve) {require(['./views/404.vue'], resolve)}
		}
	]
});

router.beforeEach((to, from, next) => {
	// 根据用户权限控制路由访问
	if (!security.auth(to.path)) {
		if (sessionStorage.getItem('token') == null) {
			// 如果未登录，跳转到登录页面
			next({path: '/login'});
			return;
		}
		// 如果已登录，跳转到403页面
		next({path: '/403'});
		return;
	}
	if (to.path == '/') {
		next('/mc/me');
		return;
	}
	next();
});

router.afterEach((to, from, next) => {
	// document.title = to.name;
	// document.title = localStorage.msg;
});

export default router;


// WEBPACK FOOTER //
// ./src/router.js